"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePrevious;
var _react = require("react");
// TODO: [P0] #4133 Don't copy.

function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfcmVhY3QiLCJyZXF1aXJlIiwidXNlUHJldmlvdXMiLCJ2YWx1ZSIsInJlZiIsInVzZVJlZiIsInVzZUVmZmVjdCIsImN1cnJlbnQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VQcmV2aW91cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBUT0RPOiBbUDBdICM0MTMzIERvbid0IGNvcHkuXG5pbXBvcnQgeyB1c2VFZmZlY3QsIHVzZVJlZiB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlUHJldmlvdXM8VD4odmFsdWU6IFQpOiBUIHtcbiAgY29uc3QgcmVmID0gdXNlUmVmPFQ+KCk7XG5cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICByZWYuY3VycmVudCA9IHZhbHVlO1xuICB9KTtcblxuICByZXR1cm4gcmVmLmN1cnJlbnQ7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBLElBQUFBLE1BQUEsR0FBQUMsT0FBQTtBQURBOztBQUdlLFNBQVNDLFdBQVdBLENBQUlDLEtBQVEsRUFBSztFQUNsRCxJQUFNQyxHQUFHLEdBQUcsSUFBQUMsYUFBTSxFQUFJLENBQUM7RUFFdkIsSUFBQUMsZ0JBQVMsRUFBQyxZQUFNO0lBQ2RGLEdBQUcsQ0FBQ0csT0FBTyxHQUFHSixLQUFLO0VBQ3JCLENBQUMsQ0FBQztFQUVGLE9BQU9DLEdBQUcsQ0FBQ0csT0FBTztBQUNwQiJ9